let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3V9JV")).then(() => parcelRequire('agzbM'));